/* eslint-disable jsx-a11y/no-onchange */
import React from 'react';
import classnames from 'classnames';
import './pricingCalculatorForm.scss';

import { TYPE_NUMBER } from 'eventbrite_design_system/inputField/constants';
import InputField from 'eventbrite_design_system/inputField/InputField';
import Button from 'eventbrite_design_system/button/Button';
import AutocompleteField from 'eventbrite_design_system/autocompleteField/AutocompleteField';
import SelectField from 'eventbrite_design_system/inputField/SelectField';
import Label from 'eventbrite_design_system/label/Label';

import Icon from 'eventbrite_design_system/icon/Icon';
import CopyChunkySvg from 'eventbrite_design_system/iconography/icons/CopyChunky';
import ChevronDownChunkySvg from 'eventbrite_design_system/iconography/icons/ChevronDownChunky';

import InfoTooltip from './InfoTooltip';

import {
    FORM_HEADLINE,
    TICKET_PRICE_LABEL,
    TICKET_QUANTITY_LABEL,
    PASS_ON_FEES_LABEL,
    PASS_ON_FEES_OPTION,
    ABSORB_FEES_OPTION,
    RESULTS_HEADLINE,
    ATTENDEE_PAYS,
    RESULTS_CTA,
    PASS_ON_FEES_SECONDARY_TEXT,
    ABSORB_FEES_SECONDARY_TEXT,
    CHANGE_PLAN_CTA,
    FEE_HANDLING_TOOLTIP_TEXT,
    ESTIMATE_TOOLTIP_TEXT,
    ESSENTIALS_LABEL,
    ESSENTIALS_DETAILS,
    PROFESSIONAL_LABEL,
    PROFESSIONAL_DETAILS,
    PACKAGE_SELECT_LABEL,
} from '../constants/pricingCalculator';

import {
    GA_PRICING_CALC_CATEGORY,
    FORM_CHANGE_PACKAGE_ACTION,
    FORM_CHANGE_TICKET_PRICE_ACTION,
    FORM_CHANGE_TICKET_QTY_ACTION,
    FORM_CHANGE_FEE_HANDLING_ACTION,
    FORM_CREATE_EVENT_ACTION,
    FORM_CHANGE_USER_PLAN_ACTION,
} from '../constants/analytics';

export default class PricingCalculatorForm extends React.PureComponent {
    render() {
        const {
            eventTotal,
            attendeeTotal,
            handleCreate,
            currencySymbol,
            ticketPrice,
            ticketQuantity,
            passOnFees,
            assortment,
            calculateFees,
            isFree,
            isLoading,
            updateEventState,
            showChangePlanCTA,
            handleChangePlan,
            updateTicketPriceState,
            trackEvent,
            openModal,
            ticketPriceError,
            ticketQuantityError,
        } = this.props;

        let changePlanCTA;
        let totalContent;
        const packageSelectOptions = [
            {
                value: 'package1',
                display: ESSENTIALS_LABEL,
            },
            {
                value: 'package2',
                display: PROFESSIONAL_LABEL,
            },
        ];
        const packageDetailText =
            assortment === 'package1'
                ? ESSENTIALS_DETAILS
                : PROFESSIONAL_DETAILS;

        if (showChangePlanCTA) {
            const changePlan = () => {
                trackEvent({
                    action: FORM_CHANGE_USER_PLAN_ACTION,
                    category: GA_PRICING_CALC_CATEGORY,
                });

                handleChangePlan();
            };

            changePlanCTA = (
                <Button type="link" style="anchor" onClick={changePlan}>
                    {CHANGE_PLAN_CTA}
                </Button>
            );
        }

        if (isFree) {
            totalContent = attendeeTotal;
        } else {
            totalContent = (
                <div className="pricing-calculator--attendee-total-link">
                    <Button onClick={openModal} type="link" style="anchor">
                        {attendeeTotal}
                    </Button>
                </div>
            );
        }

        const eventTotalClasses = classnames(
            'eds-text-color--success',
            'eds-text--center',
            'eds-l-pad-vert-4',
            'eds-text-hm',
            'pricing-calculator--results-total',
            {
                'pricing-calculator--results-total--large': !isFree,
                'eds-align--center': !isFree,
                'pricing-calculator--results-total--long':
                    !isFree && eventTotal.length > 8,
                'pricing-calculator--results-total--extra-long':
                    !isFree && eventTotal.length > 10,
            },
        );

        const createEvent = () => {
            trackEvent({
                action: FORM_CREATE_EVENT_ACTION,
                category: GA_PRICING_CALC_CATEGORY,
            });
            handleCreate();
        };

        return (
            <div
                className={`eds-bg-color--background pricing-calculator ${isLoading &&
                    'pricing-calculator--is-loading'}`}
            >
                <div className="eds-g-grid marketing-container__max-width eds-l-pad-hor-0 eds-l-mn-pad-hor-6 eds-l-md-pad-hor-6 eds-l-sm-pad-hor-4">
                    <div className="eds-group">
                        <div className="eds-g-cell eds-g-cell-md-5-12 eds-g-offset-md-2-12 eds-g-cell-1-1 eds-g-cell--has-overflow ">
                            <div className="eds-g-cell eds-g-cell-1-1 eds-g-cell-md-10-12 eds-l-mar-bot-6 eds-l-pad-bot-6 eds-l-md-mar-bot-1 eds-l-md-pad-bot-1 eds-g-cell--has-overflow">
                                <div className="pricing-calculator--form-header">
                                    <h1 className="eds-l-pad-bot-2">
                                        {FORM_HEADLINE}
                                    </h1>
                                    <div className="eds-g-grid">
                                        <div className="eds-g-cell eds-l-pad-bot-2">
                                            {packageDetailText}
                                        </div>
                                    </div>
                                </div>
                                <div className="eds-l-pad-bot-4 eds-align--space-between eds-group pricing-calculator--large-input-font">
                                    <div className="eds-g-cell eds-g-cell-5-12 eds-l-pad-left-1 pricing-calculator--price-input-error-wrapper">
                                        <InputField
                                            borderType="none"
                                            label={TICKET_PRICE_LABEL}
                                            hasError={Boolean(ticketPriceError)}
                                            annotationNote={ticketPriceError}
                                            prefix={currencySymbol}
                                            value={ticketPrice}
                                            onBlur={(value) => {
                                                trackEvent({
                                                    action: FORM_CHANGE_TICKET_PRICE_ACTION,
                                                    category: GA_PRICING_CALC_CATEGORY,
                                                });
                                                updateTicketPriceState(
                                                    value,
                                                    calculateFees,
                                                );
                                            }}
                                        />
                                    </div>
                                    <span className="eds-g-cell eds-g-cell-2-12 eds-text-hm eds-align--center eds-text--center">
                                        x
                                    </span>
                                    <div className="eds-g-cell eds-g-cell-5-12 pricing-calculator--transparent-input pricing-calculator--quantity-input-error-wrapper">
                                        <InputField
                                            borderType="none"
                                            label={TICKET_QUANTITY_LABEL}
                                            type={TYPE_NUMBER}
                                            hasError={Boolean(
                                                ticketQuantityError,
                                            )}
                                            annotationNote={ticketQuantityError}
                                            value={ticketQuantity}
                                            onChange={(value) => {
                                                trackEvent({
                                                    action: FORM_CHANGE_TICKET_QTY_ACTION,
                                                    category: GA_PRICING_CALC_CATEGORY,
                                                });
                                                updateEventState(
                                                    { ticketQuantity: value },
                                                    calculateFees,
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="eds-l-pad-bot-4 pricing-calculator--fee-container eds-align--left eds-align--center-vertical">
                                    <div className="pricing-calculator--icon-align">
                                        <InfoTooltip
                                            tooltipId="fee-tooltip"
                                            arrowLocation="left"
                                            text={FEE_HANDLING_TOOLTIP_TEXT}
                                        />
                                    </div>
                                    <div className="pricing-calculator--fee-container--autocomplete">
                                        <Label htmlFor="feeBreakdown">
                                            <span className="eds-text-bs eds-text-color--grey-600 feeBreakdown-label">
                                                {PASS_ON_FEES_LABEL}
                                            </span>
                                        </Label>
                                        <div className="fake-select--wrapper pricing-calculator--large-input-font">
                                            <AutocompleteField
                                                id="feeBreakdown"
                                                name="feeBreakdown"
                                                suggestions={[
                                                    {
                                                        key: PASS_ON_FEES_OPTION,
                                                        value: PASS_ON_FEES_OPTION,
                                                        content: PASS_ON_FEES_OPTION,
                                                        secondaryContent: PASS_ON_FEES_SECONDARY_TEXT,
                                                    },
                                                    {
                                                        key: ABSORB_FEES_OPTION,
                                                        value: ABSORB_FEES_OPTION,
                                                        content: ABSORB_FEES_OPTION,
                                                        secondaryContent: ABSORB_FEES_SECONDARY_TEXT,
                                                    },
                                                ]}
                                                value={
                                                    passOnFees
                                                        ? PASS_ON_FEES_OPTION
                                                        : ABSORB_FEES_OPTION
                                                }
                                                onSelect={(value) => {
                                                    trackEvent({
                                                        action: FORM_CHANGE_FEE_HANDLING_ACTION,
                                                        category: GA_PRICING_CALC_CATEGORY,
                                                    });
                                                    updateEventState(
                                                        {
                                                            passOnFees:
                                                                value ===
                                                                PASS_ON_FEES_OPTION,
                                                        },
                                                        calculateFees,
                                                    );
                                                }}
                                                onChange={(value) => {
                                                    trackEvent({
                                                        action: FORM_CHANGE_FEE_HANDLING_ACTION,
                                                        category: GA_PRICING_CALC_CATEGORY,
                                                    });
                                                    updateEventState(
                                                        {
                                                            passOnFees:
                                                                value ===
                                                                PASS_ON_FEES_OPTION,
                                                        },
                                                        calculateFees,
                                                    );
                                                }}
                                                borderType="none"
                                                isLimitedSearch={true}
                                                isV2={true}
                                            />
                                            <div className="fake-select--icon">
                                                <Icon
                                                    size="small"
                                                    color="ui-700"
                                                    type={
                                                        <ChevronDownChunkySvg />
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="eds-g-cell eds-g-cell-1-1 pricing-calculator--large-select-font pricing-calculator--package-select-container">
                                    <div className="eds-align--left eds-align--center-vertical">
                                        <div className="pricing-calculator--package-icon pricing-calculator--icon-align">
                                            <Icon
                                                size="xsmall"
                                                color="ui-700"
                                                type={<CopyChunkySvg />}
                                            />
                                        </div>
                                        <div className="pricing-calculator--package-select">
                                            <SelectField
                                                id="package-select"
                                                label={PACKAGE_SELECT_LABEL}
                                                borderType="none"
                                                values={packageSelectOptions}
                                                style="basic"
                                                value={assortment}
                                                onChange={(value) => {
                                                    trackEvent({
                                                        action: FORM_CHANGE_PACKAGE_ACTION,
                                                        category: GA_PRICING_CALC_CATEGORY,
                                                    });
                                                    updateEventState(
                                                        { assortment: value },
                                                        calculateFees,
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="eds-g-cell eds-g-cell-md-4-12 eds-g-cell-1-1 pricing-calculator--results">
                            <h2 className="eds-align--center eds-l-pad-bot-2">
                                {RESULTS_HEADLINE}
                                <InfoTooltip
                                    tooltipId="heading-tooltip"
                                    arrowLocation="top"
                                    superscript={true}
                                    text={ESTIMATE_TOOLTIP_TEXT}
                                />
                            </h2>
                            <div className={eventTotalClasses}>
                                {eventTotal}
                            </div>
                            <div className="eds-align--center eds-l-pad-bot-1 eds-text-bl">
                                {ATTENDEE_PAYS}
                            </div>
                            <div className="eds-align--center eds-l-pad-bot-6 eds-text-bl pricing-calculator--attendee-total">
                                {totalContent}
                            </div>
                            <div className="eds-align--center">
                                <Button onClick={createEvent} style="neutral">
                                    {RESULTS_CTA}
                                </Button>
                            </div>
                            <div className="eds-align--center pricing-calculator--change-plan-cta">
                                {changePlanCTA}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
